import React from 'react'
import { useTrans } from 'hooks'
import { ConfrontaProdotti, ListingHead, Page } from 'components/organisms'
import styles from './ConfrontaProdottiTemplate.module.sass'
import { CategoriaNode } from '@gql/graphql'

interface Props {
  pagina?: any
  categoria?: CategoriaNode
}

const ConfrontaProdottiTemplate = (props: Props) => {
  const { pagina = {}, categoria = null } = props

  const t = useTrans()

  return (
    <Page pagina={pagina} className={`${styles.root}`}>
      <main>
        <ListingHead pagina={pagina} />
        <ConfrontaProdotti categoria={categoria} />
      </main>
    </Page>
  )
}

export default ConfrontaProdottiTemplate
